import { Badge, Col, Row } from 'antd';
import KsVideoPlayer from '../../KsVideoPlayer/index';
import Styles from './index.module.scss';
import Image from 'next/image';
import { useEffect, useRef, useState } from 'react';
import { WebPNextImage } from '@/components/WebPImage';
import {
  VIDEO_PARAMS,
  VIDEO_STATEMENT,
  VIDEO_TYPES,
} from '@/utils/const/products/vod-assessment';
const fullScreenWhite =
  '/img/products/vod-assessment/videoIcons/fullScreenWhite.webp';
interface IVideoConfig {
  url: string;
  type: string;
  config: {
    resolution: string;
    bitRate: number;
    fps?: number;
  };
  [index: string]: any;
}

function videoTypeFilter(val) {
  switch (val) {
    case 'origin':
      return {
        text: VIDEO_TYPES.origin,
        className: 'videoTypeOrigin',
      };
    case 'common':
      return {
        text: VIDEO_TYPES.common,
        className: 'videoTypeCommon',
      };
    case 'zzql':
      return {
        text: VIDEO_TYPES.zzql,
        className: 'videoTypeZzql',
      };
    case 'zzyy':
      return {
        text: VIDEO_TYPES.zzyy,
        className: 'videoTypeZzql',
      };
    default:
      return {
        text: val,
        color: '',
      };
  }
}
interface IProps {
  src: string;
  sourceVideos: IVideoConfig[];
}

const CombineVideoPlayer = ({ src, sourceVideos }: IProps) => {
  // mask
  const [showMask, setShowMask] = useState(false);
  const VideoMask = ({ sourceVideos }: { sourceVideos: IVideoConfig[] }) => {
    const requestFullScreen = (url) => {
      ksVideoPlayerRef.current.fullScreenCustomUrl(url);
    };
    const maskNumber = sourceVideos.length;
    sourceVideos.forEach(
      (item) => (item.typeConfig = videoTypeFilter(item.type))
    );

    return (
      <div className={Styles.videoInfoMask}>
        {sourceVideos.map(({ config, type, typeConfig, url }) => {
          return (
            <div
              style={{
                width: maskNumber === 2 ? 546 : 325,
                height: maskNumber === 2 ? 278 : 576,
              }}
              key={type}
              className={Styles.maskItemContainer}
            >
              <div className={Styles.videoInfoContainer}>
                <div className={Styles.videoInfo}>
                  {config?.resolution && (
                    <div>
                      <span className={Styles.videoInfoLabel}>
                        {VIDEO_PARAMS.resolution}：
                      </span>
                      <span>{config?.resolution}</span>
                    </div>
                  )}
                  {config?.bitRate && (
                    <div>
                      <span className={Styles.videoInfoLabel}>
                        {VIDEO_PARAMS.bitRate}：
                      </span>
                      <span>{config?.bitRate}kbps</span>
                    </div>
                  )}
                  {config?.fps && (
                    <div>
                      <span className={Styles.videoInfoLabel}>
                        {VIDEO_PARAMS.fps}：
                      </span>
                      <span>{config?.fps}</span>
                    </div>
                  )}
                </div>
                <span
                  className={`${Styles.videoType} ${
                    Styles[typeConfig.className]
                  }`}
                >
                  {typeConfig.text}
                </span>
              </div>
              <div className={Styles.operationIconContainer}>
                <WebPNextImage
                  src={fullScreenWhite}
                  className={Styles.operationIcon}
                  alt="fullScreen"
                  width={18}
                  height={18}
                  onClick={() => requestFullScreen(url)}
                  crossOrigin="anonymous"
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const [row, setRow] = useState(0);

  useEffect(() => {
    setRow(sourceVideos.length);
  }, [sourceVideos]);

  const ksVideoPlayerRef = useRef(null);

  return (
    <div className={Styles.videoContainer}>
      {showMask && <VideoMask sourceVideos={sourceVideos} />}
      <KsVideoPlayer
        src={src}
        style={{ width: 1032, height: 580 }}
        ref={ksVideoPlayerRef}
        showCustomerControl
        playerLoaded={() => setShowMask(true)}
      />
      <div className={Styles.videoStatement}>
        <Badge color="#999999" />
        {VIDEO_STATEMENT}
      </div>
    </div>
  );
};

export default CombineVideoPlayer;
